export default "__VITE_ASSET__BR$Prhft__"